// extracted by mini-css-extract-plugin
export default {"container":"UnreadIndicator-module__container--Gifky"};